const constants = require('./config/constants.' + process.env.REACT_APP_ENVIRONMENT);

export const URL = {
	get user() {
    const controller = '/api/v1/user';
    return getCollegiateApiUrl(controller);
  },
	get event() {
    const controller = '/api/v1/events';
    return getCollegiateApiUrl(controller);
  },
	get season() {
    const controller = '/api/v1/seasons';
    return getCollegiateApiUrl(controller);
  },
	get seasonsettings() {
    const controller = '/api/v1/seasonsettings';
    return getCollegiateApiUrl(controller);
  },
	get member() {
    const controller = '/api/v1/member';
    return getCollegiateApiUrl(controller);
  },
  get postevent() {
    const controller = '/api/v1/postevent';
    return getCollegiateApiUrl(controller);
  },
  get reports() {
    const controller = '/api/v1/reports';
    return getCollegiateApiUrl(controller);
  },
  get center() {
    return getSearchServiceUrl('/api/v1/centers');
  },
	get school() {
    return getSearchServiceUrl('/api/v1/collegiate/schools');
  },
	get team() {
    return getSearchServiceUrl('/api/v1/collegiate/teams?schoolid=');
  },
	get athlete() {
    return getSearchServiceUrl('/api/v1/collegiate/athletes?teamid=');
  }
}

export const UserManagerConfig = {
  authority: constants.ssoUrl,
  client_id: constants.clientId,
  redirect_uri: constants.siteUrl + "/signin-oidc",
  response_type: "id_token token",
  scope: "openid profile " + constants.apiScope,
  post_logout_redirect_uri: constants.siteUrl + "/signout-callback-oidc",
  silent_redirect_uri: constants.siteUrl + "/signin-silentrenew",
  automaticSilentRenew: true
}

function getCollegiateApiUrl(route) {
  return `${constants.collegiateApiUrl}${route}`;
}

function getSearchServiceUrl(route) {
  return `${constants.searchServiceUrl}${route}`;
}

export function GetEditProfileURL() {
    return constants.ssoProfileUrl;
}


// WEBPACK FOOTER //
// ./src/config.js